import * as moment from 'moment';
import { LoginActionTypeKeys, LoginActionTypes } from "../actions/loginActionTypes";
import initialState from "./authenticationInitialState";

export default (
  state = initialState,
  action: LoginActionTypes
) => {
  switch (action.type) {
    case LoginActionTypeKeys.SIGNIN_SUCCESS:
      return { ...state, isAuthenticated: true, wsid: action.wsid, csrf: action.csrf, user: action.user, loginTime: moment.now() };
    case LoginActionTypeKeys.SIGNOUT_SUCCESS:
    case LoginActionTypeKeys.SIGNIN_FAIL:
      return { ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authenticationReducer.ts